<template>
  <div v-if="loading" class="clearfix">
    <b-spinner class="float-right" label="Floated Right" />
  </div>
  <div v-else>
    <b-tabs v-model="activeTab" @input="onTabChange">
      <!-- ATENDIMENTO -->
      <b-tab>
        <template #title>
          <feather-icon icon="ClockIcon" />
          <span>Atendimentos </span>
        </template>
        <app-collapse type="margin">
          <app-collapse-item title="Atendimentos" :isVisible="true">
            <ProfissionalAtendimentoForm
              @disable-form-changed="handleDisableFormChange"
            />
          </app-collapse-item>
        </app-collapse>
      </b-tab>
      <b-tab
        v-for="grupo in listaGrupo"
        :key="grupo.id"
        @click="loadProcedimentos(grupo)"
      >
        <template #title>
          <feather-icon icon="CheckIcon" />
          <span>{{ grupo.nome }}</span>
        </template>
        <app-collapse type="margin">
          <app-collapse-item :title="grupo.nome" :isVisible="true">
            <div v-if="loadingProcedimentos" class="text-center py-3">
              <b-spinner />
              <div class="mt-2">Carregando...</div>
            </div>
            <ProcedimentosForm
              v-else
              :procedimentos="listaProcedimentos"
              :grupo="grupo"
            />
          </app-collapse-item>
        </app-collapse>
      </b-tab>
      <!-- HISTORICO -->
      <!-- ABAS DINAMICAS -->
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { BSpinner, BTabs, BTab } from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import mixinsGlobal from "@/mixins";
import ProfissionalAtendimentoForm from "./ProfissionalAtendimentoForm.vue";
import ProcedimentosForm from "./ProcedimentosForm.vue";

const INACTIVITY_TIMEOUT = 3 * 60 * 1000;
const AUTO_SAVE_INTERVAL = 10000;
const TAB_CHANGE_CONFIG = {
  title: "Atenção",
  variant: "warning",
  solid: true,
  toaster: "b-toaster-top-center",
  noAutoHide: false,
};

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BSpinner,
    BTabs,
    BTab,
    ProfissionalAtendimentoForm,
    ProcedimentosForm,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("atendimentoProfissionalModule", {
      atendimento: (state) => state.atendimento,
    }),
    hasProcedimentos() {
      return this.listaProcedimentos && this.listaProcedimentos.length > 0;
    },
  },
  data() {
    return {
      collapseType: "default",
      loading: false,
      loadingProcedimentos: false,
      activeTab: 0,
      previousTab: 0,
      disableForm: true,
      inactivityTimer: null,
      inactivityTimeout: INACTIVITY_TIMEOUT,
      lastActivity: Date.now(),
      listaGrupo: [],
      listaProcedimentos: [],
    };
  },
  methods: {
    async loadProcedimentos(grupo) {
      this.loadingProcedimentos = true;

      try {
        const obj = {
          grupo: grupo.id,
          paciente: this.atendimento.registro.id,
        };
        const response = await this.$store.dispatch(
          "atendimentoProfissionalModule/loadProcedimentosByPacienteAndGrupo",
          obj,
        );
        this.listaProcedimentos = response.data;
      } catch (error) {
        console.error("Error loading procedimentos:", error);
      } finally {
        this.loadingProcedimentos = false;
      }
    },
    handleDisableFormChange(disableFormValue) {
      this.disableForm = disableFormValue;
    },
    // Métodos de ciclo de vida e configuração
    setupActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.addEventListener(event, this.resetInactivityTimer);
      });
    },
    removeActivityListeners() {
      const events = [
        "mousemove",
        "mousedown",
        "keypress",
        "touchmove",
        "click",
        "scroll",
      ];
      events.forEach((event) => {
        document.removeEventListener(event, this.resetInactivityTimer);
      });
    },
    resetInactivityTimer() {
      this.lastActivity = Date.now();
    },
    onTabChange(newTab) {
      if (!this.disableForm) {
        if (this.activeTab === this.previousTab) {
          return;
        }

        this.$bvToast.toast(
          "Por favor, salve ou cancele as alterações antes de trocar de aba.",
          TAB_CHANGE_CONFIG,
        );

        this.$nextTick(() => {
          this.activeTab = this.previousTab;
        });
        return;
      }

      this.previousTab = this.activeTab;
    },
    async montarAbasDeGrupos() {
      try {
        const response = await this.$store.dispatch(
          "atendimentoProfissionalModule/montarAbasGrupo",
          this.$route.params.id,
        );
        this.listaGrupo = response.data;
      } catch (error) {
        console.error("Error loading grupos:", error);
      }
    },
  },
  async mounted() {
    this.setupActivityListeners();
    await this.montarAbasDeGrupos();
  },
  beforeDestroy() {
    this.removeActivityListeners();
    this.clearInactivityTimer();
  },
};
</script>
